
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { list_type, record_type, option_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export function ScanResultType__ToI18nString(this$) {
    switch (this$) {
        case "toolWithQuantity":
            return "variable.tool_with_quantity";
        case "consumable":
            return "general.consumable";
        case "set":
            return "general.set";
        case "receiver":
            return "general.receiver";
        default:
            return "variable.tool";
    }
}

export class ScanMatch extends Record {
    constructor(Id, Type, Name, AdditionalName, Unit, InventoryNumber, Manufacturer, Model, SerialNumber, ImageUrl, StorageName, StorageId, LocationName, StorageSpace, AssignedReceiver) {
        super();
        this.Id = Id;
        this.Type = Type;
        this.Name = Name;
        this.AdditionalName = AdditionalName;
        this.Unit = Unit;
        this.InventoryNumber = InventoryNumber;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.SerialNumber = SerialNumber;
        this.ImageUrl = ImageUrl;
        this.StorageName = StorageName;
        this.StorageId = StorageId;
        this.LocationName = LocationName;
        this.StorageSpace = StorageSpace;
        this.AssignedReceiver = AssignedReceiver;
    }
}

export function ScanMatch_$reflection() {
    return record_type("Shared.Scan.ScanMatch", [], ScanMatch, () => [["Id", string_type], ["Type", string_type], ["Name", option_type(string_type)], ["AdditionalName", option_type(string_type)], ["Unit", option_type(string_type)], ["InventoryNumber", option_type(string_type)], ["Manufacturer", option_type(string_type)], ["Model", option_type(string_type)], ["SerialNumber", option_type(string_type)], ["ImageUrl", option_type(string_type)], ["StorageName", option_type(string_type)], ["StorageId", option_type(string_type)], ["LocationName", option_type(string_type)], ["StorageSpace", option_type(string_type)], ["AssignedReceiver", option_type(string_type)]]);
}

export class ScanResult extends Record {
    constructor(Matches) {
        super();
        this.Matches = Matches;
    }
}

export function ScanResult_$reflection() {
    return record_type("Shared.Scan.ScanResult", [], ScanResult, () => [["Matches", list_type(ScanMatch_$reflection())]]);
}

